{{custom-wizard-time-input
  date=this.time
  onChange=(action "onChange")
  tabindex=this.field.tabindex
}}